<canvas #canvasElement class="cm-canvas" resize (contextmenu)="(false)"></canvas>
